import { Autocomplete, FormHelperText, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../redux/types'

interface ILanguage {
  id: number
  name: string
}

export function UserLanguageAutocomplete({ userLanguages, handleInputChange }: any) {
  const { t } = useTranslation(['global'])

  const { errorForm, msgForm } = useSelector((state: IRootState) => state.validator)
  const { languages } = useSelector((state: IRootState) => state.language)

  const handleMultiAutoCompleteChange = (brands: ILanguage[]) => {
    let optionsMulti: number[] = []
    if (brands !== null) {
      for (let i = 0; i < brands.length; i++) {
        optionsMulti.push(brands[i].id)
      }
    }

    handleInputChange('languages', optionsMulti)
  }

  return (
    <>
      <Autocomplete
        id="multi-autocomplete-languages"
        value={languages.filter((language: any) => userLanguages.includes(language.id))}
        onChange={(_, value) => handleMultiAutoCompleteChange(value)}
        options={languages}
        multiple
        fullWidth
        getOptionLabel={(option: any) => (option.id !== undefined ? option.name : '')}
        renderInput={params => (
          <TextField required {...params} label={t('language')} error={errorForm.languages} variant="filled" InputLabelProps={{ shrink: true }} />
        )}
      />
      <FormHelperText error={errorForm.languages}>{msgForm.languages}</FormHelperText>
    </>
  )
}
